import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useShop } from '../context/ShopContext';
import { FaSpinner } from 'react-icons/fa';
import Sidebar from "./Sidebar";
import EmptyState from "./EmptyState";

const Commissiondesi = () => {
    const [products, setProducts] = useState([]);
    const [amounts, setAmounts] = useState({});
    const [loading, setLoading] = useState(true);
    const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
    const inputRefs = useRef([]);
    const { shopId , companyId} = useShop();
    const [partyMasters, setPartyMasters] = useState([]);
    const [selectedParty, setSelectedParty] = useState("");
    const [selectedPartyId, setSelectedPartyId] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
   




  const showToast = (message, type = "error") => {
                toast.dismiss(); // Dismiss any existing toast before showing a new one
              
                console.log("Toast Type:", type); // Debugging log to check type value
              
                if (type.toLowerCase() === "error") {
                  toast.error(message);
                } else if (type.toLowerCase() === "success") {
                  toast.success(message);
                } else {
                  console.warn("Invalid toast type:", type);
                }
              };








    const fetchProducts = async () => {
        try {
            setLoading(true);
            console.log("Fetching products for:", { shopId, date });
    
            // Validate date before conversion
            const formattedDate = date ? new Date(date).toISOString() : null;
            if (!formattedDate) {
                throw new Error("Invalid date provided.");
            }
    
            const response = await axios.post(
                "https://winenew.sipstocks.in/api/Liquor/GetTodaySalesProduct",
                {
                    shopId: shopId,
                    typeId: "2",
                    stockDate: date || new Date().toISOString().split("T")[0], // Ensure valid date format
                },
                {
                    headers: {
                        "accept": "*/*",
                        "Content-Type": "application/json",
                    }
                }
            );
    
            console.log("API Response Comission:", response);
    
            if (response.data?.code === 200 && Array.isArray(response.data.data)) {
                const formattedProducts = response.data.data.map(product => ({
                    id: product.id,
                    pName: product.pName,
                    packing: product.packing,
                    mrp: parseFloat(product.mrp) || 0,
                    totalSale: Math.round(parseFloat(product.salesToday) || 0),
                }));
    
                setProducts(formattedProducts);
    
                // Initialize amounts with commissionSale as empty and counterSale from totalSale
                const initialAmounts = formattedProducts.reduce((acc, product) => {
                    acc[product.id] = {
                        commissionSale: "",
                        counterSale: product.totalSale,
                    };
                    return acc;
                }, {});
    
                setAmounts(initialAmounts);
            } else {
                showToast(response.data?.message || "Failed to fetch products","error");
                setProducts([]);
            }
        } catch (error) {
            console.error("API Error:", error);
            showToast(error.response?.data?.message || "Error fetching products","error");
            setProducts([]);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchProducts();
    }, [date]);




    const handleInputChange = (id, field, value) => {
          let product = products.find(p => p.id === id);
    
        setAmounts(prev => {
            let updatedAmount = { ...prev[id] };
    
            if (field === "commissionSale") {
                let commissionSale = value ? parseFloat(value) : 0;
                let totalSale = product.totalSale;
                let counterSale = totalSale - commissionSale;
    
                if (commissionSale < 0) {
                    showToast('Commission Sale cannot be negative', "error");
                    return prev;
                }
    
                if (commissionSale > totalSale) {
                    showToast('Commission Sale cannot be greater than Total Sale', "error");
                    return prev;
                }
    
                updatedAmount.commissionSale = commissionSale;
                updatedAmount.counterSale = counterSale;
            } 
            else if (field === "commissionValue") {
                let commissionValue = value ? parseFloat(value) : ""; 
                let commissionSale = prev[id]?.commissionSale || 0;
                let maxCommissionValue = commissionSale * product.mrp;
    
                if (commissionValue < 0) {
                    showToast('Commission Value cannot be negative', "error");
                    updatedAmount.commissionValue = ""; 
                    updatedAmount.commissionPercent = ""; // reset percent
                    return { ...prev, [id]: updatedAmount };
                }
    
                if (commissionValue > maxCommissionValue) {
                    showToast(`Commission Value cannot exceed ${maxCommissionValue}`, "error");
                    updatedAmount.commissionValue = ""; 
                    updatedAmount.commissionPercent = ""; // reset percent
                    return { ...prev, [id]: updatedAmount };
                }
    
                updatedAmount.commissionValue = commissionValue; 
    
              
                // Updated commission percent calculation
    if (commissionSale > 0 && product.mrp > 0) {

        console.log("commissionValue",commissionValue)
        console.log("commissionSale * product.mrp",commissionSale * product.mrp)
        updatedAmount.commissionPercent = ((commissionValue / (commissionSale * product.mrp)) * 100).toFixed(2);

        console.log("update amount:",updatedAmount.commissionPercent)
    } else {
                    updatedAmount.commissionPercent = "0.00";
                }
            } 
            else if (field === "remark") {
                updatedAmount.remark = value; 
            }
    
            return { ...prev, [id]: updatedAmount };
        });
    };
    
    
    
 const handleSubmit = async () => {
        // Check if party is selected before submitting
        if (!selectedPartyId) {
            showToast("Please select a party before submitting!", "error");
            return; // stop submission
        }
    
        try {
            setLoading(true);
    
            const dataToSubmit = products
                .map((product, index) => {
                    const commissionSale = parseFloat(amounts[product.id]?.commissionSale) || 0;
                    const commissionValue = parseFloat(amounts[product.id]?.commissionValue) || 0;
                    const remark = amounts[product.id]?.remark || "";
                    const rate = product.mrp; 
    
                    if (commissionSale === 0 && commissionValue === 0) {
                        return null; 
                    }
    
                    const totalSale = product.totalSale;
                    const counterSale = totalSale - commissionSale;
    
                    // Calculate ProductPerCommission (percentage)
                    let productPerCommission = 0;
                    if (rate > 0) {
                        productPerCommission = ((commissionValue / (commissionSale * product.mrp)) * 100).toFixed(2);
                    }
    
                    return {
                        Id: index + 1,
                        ProductId: product.id,
                        ShopId: shopId,
                        rate: parseFloat(rate.toFixed(2)), 
                        CommissionSale: parseFloat(commissionSale.toFixed(2)),
                        CounterSale: parseFloat(counterSale.toFixed(2)),
                        TotalSale: totalSale,
                        CommissionValue: parseFloat(commissionValue.toFixed(2)),
                        SaleDate: date || new Date().toISOString().split("T")[0], // Ensure valid date format
                        RectimeStamp: date || new Date().toISOString().split("T")[0], // Ensure valid date format
                        Remark: remark,
                        CommissionId: selectedPartyId,
                        ProductPerCommission: productPerCommission,
                    };
                })
                .filter(item => item !== null);
    
            console.log("📊 Payload JSON:", JSON.stringify(dataToSubmit, null, 2));
    
            if (dataToSubmit.length === 0) {
                showToast("No valid data to submit!", "error");
                setLoading(false);
                return;
            }
    
            const response = await axios.post(
                "https://winenew.sipstocks.in/api/Liquor/SaveCommissionData",
                dataToSubmit,
                {
                    headers: {
                        "accept": "*/*",
                        "Content-Type": "application/json",
                    }
                }
            );
    
            if (response.data.code === 200) {
                showToast("Data submitted successfully!", "success");
                setTimeout(() => window.location.reload(), 2000);
                setAmounts({});
            } else {
                showToast("Failed to submit data", "error");
            }
        } catch (error) {
            showToast("Error submitting data", "error");
            console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    };
    
    
    
    
    

    const isSubmitEnabled = Object.values(amounts).some(amount => parseFloat(amount?.commissionSale) > 0);
    const totalCommissionValue = Object.values(amounts).reduce((sum, item) => {
        const value = parseFloat(item?.commissionValue) || 0;
        return sum + value;
      }, 0);
      const totalSale = products.reduce((sum, product) => sum + product.totalSale, 0);

const totalCommissionSaleRate = products.reduce((sum, product) => {
    const commissionSale = amounts[product.id]?.commissionSale || 0;
    return sum + (commissionSale * product.mrp);
}, 0);
      

const Netsale = totalCommissionSaleRate-totalCommissionValue



const netPercentage = totalCommissionSaleRate > 0 
  ? ((totalCommissionValue / totalCommissionSaleRate) * 100).toFixed(2) 
  : "0.00";


    useEffect(() => {
        const fetchPartyMasters = async () => {
          try {
            const response = await axios.post(
              'https://winenew.sipstocks.in/api/Liquor/GetCommissionHead',
              { companyId },
              { headers: { accept: '*/*' } }
            );
            console.log("fetchPartyMasters", response);
      
            const options = response.data?.data?.map((item) => ({
              id: item.id,
              label: item.name,
            }));
            setPartyMasters(options);

          } catch (err) {
            console.error('Error fetching party master options:', err);
            showToast('Failed to load Comission Head.',"error");
          }
        };
      
        fetchPartyMasters();
      }, []);

    return (
         <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
         {/* Content wrapper */}
         <div className="d-flex flex-column flex-column-fluid">
             {/* Toolbar */}
             <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                 {/* Toolbar container */}
                 <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                     {/* Page title */}
                     <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                         {/* Title */}
                         <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                         Comission
                         </h1>
                         <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                             <li className="breadcrumb-item text-muted">
                                 <a href="index.html" className="text-muted text-hover-primary">Home</a>
                             </li>
                             <li className="breadcrumb-item">
                                 <span className="bullet bg-gray-500 w-5px h-2px"></span>
                             </li>
                             <li className="breadcrumb-item text-muted">Dashboards</li>
                         </ul>
                     </div>
                 </div>
             </div>
       
             <div id="kt_app_content" className="app-content flex-column-fluid">
                 <div id="kt_app_content_container" className="app-container container-fluid">
                     <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                         <div className="col-xl-12">
                             <div className="card card-flush h-md-100">
                                  <ToastContainer />
                                 
                                 <div className="card-body pt-6">
                                     <div className="table-responsive">
                                         <div className="panel-body">
                                             <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                 <form className="form-inline">
                                                     <div className="form-group">
                                             
                                                <div className="form-group d-flex justify-content-between gap-5">
                                                <div className="col-lg-3 col-6">
                                                <label htmlFor="language" className="form-label">
      Date:
      </label>

  <input
    type="date"
    className="form-control "
    value={date} // Always in correct format
    max={new Date().toISOString().split("T")[0]} // Restrict future dates
    onChange={(e) => setDate(e.target.value)} // Update state
  />
</div>
<div className="col-lg-3 col-6">
      <label htmlFor="language" className="form-label">
      Comission Head
      </label>
    <select
  className="form-control"
  id="partyMaster"
  value={selectedPartyId}
  onChange={(e) => setSelectedPartyId(e.target.value)}
>
  <option value="">Select Head</option>
  {partyMasters.map((party) => (
    <option key={party.id} value={party.id}>
      {party.label}
    </option>
  ))}
</select>
 </div>
 <div className="col-lg-3 col-6">
  <label htmlFor="productSearch" className="form-label">Search Product</label>
  <input
    type="text"
    id="productSearch"
    className="form-control"
    placeholder="Search product"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
  />
</div>
                           
                                                       
                                                     </div>

 </div>
    
                                                 </form>
                                             </div>
                                             <div className="clearfix"></div>
                                             <br />
    
                                               <div className="table-responsive h-700px">
                                                {loading ? (
                                             <div className="loader-container">
                                                 <FaSpinner className="spinner-icon" />
                                             </div>
                                         ) : products.length  > 0 ? (
                                            <table className="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Product Name</th>
                                                    <th>Rate</th>
                                                    <th>Variant</th>
                                                    <th>Total Sale</th>
                                                    <th>Commission Sale</th>
                                                    <th>Counter Sale</th>
                                                    <th>Commission Value</th>
                                                    <th>Commission %</th>
                                                    <th>Remark</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {products
  .filter(product =>
    product.pName.toLowerCase().includes(searchQuery.toLowerCase())
  )
  .map((product, index) => (
                                                    <tr key={product.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{product.pName}</td>
                                                        <td>{product.mrp}</td>
                                                        <td>{product.packing}</td>
                                                        <td>{product.totalSale}</td>
                                                        <td>
        <input
            type="text"
            className="form-control"
            value={amounts[product.id]?.commissionSale || ""}
            onChange={(e) => handleInputChange(product.id, "commissionSale", e.target.value)}
        />
        </td>
        <td>
        {amounts[product.id]?.commissionSale
        ? amounts[product.id]?.counterSale
        : ""}
        </td>
        <td>
        <input
            type="text"
            className="form-control"
            value={amounts[product.id]?.commissionValue ?? ""} 
            onChange={(e) => handleInputChange(product.id, "commissionValue", e.target.value)}
        />
        </td>
        <td>{amounts[product.id]?.commissionPercent }</td>
        <td>
        <input 
            type="text" 
            className="form-control" 
            value={amounts[product.id]?.remark || ""} 
            onChange={(e) => handleInputChange(product.id, "remark", e.target.value)} 
        />
        </td>
    
                                                    </tr>
                                                ))}
                                            </tbody>

                                        </table>
                                        
                                      ) : (
                                       <EmptyState />
                                          )}
                                              </div>
                                              <tfoot>
  <tr>
    <td colSpan="6" className="text-end"><strong>Total Commission Value:</strong></td>
    <td colSpan="4"><strong>₹{totalCommissionValue.toFixed(2)}</strong></td>
  </tr>
  <tr>
    <td colSpan="6" className="text-end"><strong>Total Sale:</strong></td>
    <td colSpan="4"><strong>₹{totalCommissionSaleRate.toFixed(2)}</strong></td>
  </tr>
  <tr>
    <td colSpan="6" className="text-end"><strong>Net Sale:</strong></td>
    <td colSpan="4"><strong>₹{Netsale.toFixed(2)}</strong></td>
  </tr>
  <tr>
    <td colSpan="6" className="text-end"><strong>Net % :</strong></td>
    <td colSpan="4"><strong>{netPercentage}%</strong></td>
  </tr>
</tfoot>

                                              
     
     
     
                                               <div class="text-right align-items-right d-flex justify-content-end">
                                               <button className="btn btn-primary" onClick={handleSubmit} disabled={!isSubmitEnabled || loading}>
                            {loading ? "Submitting..." : "Submit"}
                        </button>
                                            
   
                                               </div>
   
                                          </div>
                                         
                                     </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
         </div>
       
         {/* Footer */}
         <div id="kt_app_footer" className="app-footer">
             <div className="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3">
                 <div className="text-gray-900 order-2 order-md-1">
                     <span className="text-muted fw-semibold me-1">2025&copy;</span>
                     <a href="#" target="_blank" className="text-gray-800 text-hover-primary">WineShop</a>
                 </div>
             </div>
         </div>
      </div>
    )
};

export default Commissiondesi;
